import React, { useEffect } from 'react';  
import Leftside from './Leftside';  
import Header from './Header';   
// import ItemService from "../../services/commonService";
import { Outlet } from 'react-router-dom'; 
import Constants from "../../common/Constants";
import { useSelector } from 'react-redux';

const Layout = () => {  
    // const [menu, setMenu] = useState([]);
    const userData = useSelector((state) => state?.user); // User Details from Store

    // Fetch menu list on component mount
    // useEffect(() => {
    //     const getMenuList = async () => {
    //         try {
    //             const items = await ItemService.getMenuList();
    //             setMenu(items);
    //         } catch (error) {
    //             console.error("Failed to fetch menu list:", error);
    //         }
    //     };

    //     getMenuList();
    // }, []); // Empty dependency array ensures this runs only once, like componentDidMount

    useEffect(() => {
        if(userData?.data?.category !== (Constants.MASTER.USERS.TEAMLEAD || Constants.MASTER.USERS.OPERATOR))  {
            document.body.classList.add("toggle-sidebar");
        } else {
            document.body.classList.remove("toggle-sidebar");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array ensures this runs only once, like componentDidMount

    // const loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>;

    return (  
        <div>  
            <div id="wrapper">  
                { userData?.data?.category === Constants.MASTER.USERS.ADMIN && <Leftside /> }
                <Header /> 
                <Outlet />
            </div>  
        </div>  
    );  
};

export default Layout;